import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import './style.scss';

const Footer = () => (
	<StaticQuery
		query={graphql`
			query SocialQuery {
				site {
					siteMetadata {
						facebook
					}
				}
			}
		`}
		render={data => (
			<footer className="footer center">
				<div className="content has-text-centered">
					<p className="is-size-7">© {(new Date().getFullYear())} Mar Barahona Photography. All Rights Reserved</p>
				</div>
			</footer>
		)}
	/>
);

export default Footer;
